import { render } from "./NiceImage.vue?vue&type=template&id=e663a956"
import script from "./NiceImage.vue?vue&type=script&lang=js"
export * from "./NiceImage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Eduardo\\Documents\\RadSystems\\PHPRad Projects\\analitycs\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__